import React from 'react';
import PropTypes from 'prop-types';
import * as styles from './sticky-sidebox.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var StickySidebox = props => ___EmotionJSX("div", {
  css: styles.stickySidebox,
  className: props.className
}, props.children);
StickySidebox.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};
StickySidebox.defaultProps = {
  className: undefined
};
export default StickySidebox;